<app-header [title]="'Create/Edit Combos'" (back)="router.navigate(['/home'])"></app-header>

<ion-content>
  @if (userService.merchants.length > 1) {
    <div class="select-label">{{ i18n.instant('products.merchant') }}</div>
    <ion-item class="default-input merchant">
      <ion-select
        (ionChange)="onMerchantChange($event)"
        [value]="activeMerchantId"
        [placeholder]="i18n.instant('products.select_one')"
        >
        @for (merchant of userService.merchants; track merchant._id) {
          <ion-select-option [value]="merchant._id" [disabled]="!merchant.enableComboOffers">{{
            merchant.name
          }}</ion-select-option>
        }
      </ion-select>
    </ion-item>
  }

  @if (activeMerchantId) {
    <button
      class="action-btn"
      style="margin: 20px 0"
      (click)="openComboModal()"
      >
      + Create Combo
    </button>
  }

  @for (combo of combos; track combo._id) {
    <app-combo-preview
      [combo]="combo"
      [products]="products"
      [merchant]="userService.getMerchantById(activeMerchantId)"
      [imagesLinks]="imagesLinks"
      (edit)="openComboModal($event)"
      (remove)="removeCombo($event)"
    ></app-combo-preview>
  }
</ion-content>
